import * as angular from 'angular';

export class ExternalAncillariesService {

    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsHttpServicesConstants: CommonsHttpServicesConstantsType,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy
    ) { }

    getBobPickUpSlots = (area: any) => {
        const checkinId: string = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.bobPickupSlotsURI;
        const uri = endpoint.replace('{flowId}', checkinId);
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.postGeneric(uri, area).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    validateBobAddress = (addressInfo: any) => {
        const checkinId: string = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.bobValidateAddressURI;
        const uri = endpoint.replace('{flowId}', checkinId);
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.postGeneric(uri, addressInfo).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    createBobOrder = (bobOrder: any) => {
        const checkinId: string = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.bobCreateURI;
        const uri = endpoint.replace('{flowId}', checkinId);
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.postGeneric(uri, bobOrder).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    getExternalAncillariesInfo = (orderId: any, offerId: any) => {
        let endpoint: string;
        endpoint = endpoint ? (endpoint + this.CommonsHttpServicesConstants.DEFAULT_ENDPOINTS.externalAncillariesURI) : this.CommonsHttpServicesConstants.DEFAULT_ENDPOINTS.externalAncillariesURI;
        endpoint = endpoint + orderId + '/offerId/' + offerId;
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(endpoint).then(
                (alpData)=> {
                    this.localStorageService.set('alpInfo', alpData.data);
                    resolve(alpData.data);
                },
                (error) => {
                    reject(null);
                });
        });
    };

    getExternalAncillaryUrl = (orderId: any, offerId: any, requestData: any, defered?: any ) => {
        let endpoint: string;
        const fareData: any = this.localStorageService.get('fareData');
        let flowId: string = '';
        if (fareData && fareData.responseId) {
            flowId = fareData.responseId;
        }
        if (offerId === null) {
            endpoint = this.AncillariesConstants.DEFAULT_ENDPOINTS.externalAncillariesCloudURI;
            endpoint = endpoint.replace('{flowId}', orderId);
        } else {
            endpoint = this.CommonsHttpServicesConstants.DEFAULT_ENDPOINTS.externalAncillariesURICloudURI.replace('{flowId}', flowId);
        }
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                accept: '*/*'
            }
        };
        return new Promise((resolve, reject) => {
            if (offerId === null) {
                this.CommonsGenericProxy.postGeneric(endpoint, requestData).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });
            } else {
                this.CommonsGenericProxy.putGeneric(endpoint, requestData, headerConfig).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });
            }
        });
    };
}
ExternalAncillariesService.$inject = ['AncillariesConstants', 'localStorageService', 'CommonsHttpServicesConstants', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy'];
try {
    const mod = angular.module('ib-web-ancillaries-services-module');
    mod.service(
        'ExternalAncillariesService',
        ExternalAncillariesService
    );
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-services-module', []);
    mod.service(
        'ExternalAncillariesService',
        ExternalAncillariesService
    );
}